<template>
  <ul class="form-item-list">
    <li><h3>키와 몸무게를 입력해주세요</h3></li>
    <li>
      <div class="label">{{ formData.키.label }}</div>
      <el-input
        type="text"
        v-model="formData.키.value"
        :placeholder="formData.키.placeholder"
      >
        <span slot="suffix">cm</span>
      </el-input>
    </li>
    <li>
      <div class="label">{{ formData.몸무게.label }}</div>
      <el-input
        type="text"
        v-model="formData.몸무게.value"
        :placeholder="formData.몸무게.placeholder"
      >
        <span slot="suffix">kg</span>
      </el-input>
    </li>
  </ul>
</template>

<script>
import { Checkbox, Row, Col, Input } from 'element-ui';

export default {
  name: 'Info',
  props: ['formData'],
  components: {
    [Checkbox.name]: Checkbox,
    [Row.name]: Row,
    [Col.name]: Col,
    [Input.name]: Input,
  },
  watch: {
    'formData.키.value': function (n) {
      this.update('키', n);
    },
    'formData.몸무게.value': function (n) {
      this.update('몸무게', n);
    },
  },
  methods: {
    update(type, value) {
      if (value !== '') {
        this.$emit('update', { type, value });
      }
    }
  }
}
</script>

<style lang="scss">
.form-item-list {
  li {
    &.text-center {
      text-align: center;
    }
    h3 {
      font-size: 18px !important;
    }
    p {
      span.blue {
        color: #174BE6;
      }
    }

    .el-input {
      height: 54px;

      .el-input__inner {
        height: 54px;
        border-radius: 0;
      }

      .el-input__suffix-inner {
        line-height: 54px;
        color: #000;
      }
    }
  }
}
</style>